import { render, staticRenderFns } from "./ServiceAttention.vue?vue&type=template&id=0111fe03"
import script from "./ServiceAttention.vue?vue&type=script&lang=js"
export * from "./ServiceAttention.vue?vue&type=script&lang=js"
import style0 from "./ServiceAttention.vue?vue&type=style&index=0&id=0111fe03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports